// ==========================================
// Merkezi API Yapılandırması
// Tüm adresler .env dosyasından okunur.
// Yerel geliştirmede .env boşsa aşağıdaki varsayılanlar kullanılır.
// ==========================================
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || 'http://localhost:5000/uploads';

export default API_URL;
